import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=70fa173c&scoped=true&"
import script from "./LoadingOverlay.vue?vue&type=script&lang=ts&"
export * from "./LoadingOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingOverlay.vue?vue&type=style&index=0&id=70fa173c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa173c",
  null
  
)

export default component.exports